var React = require('react');

function DifficultyLevelBlueOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"difficulty-level-blue-outline"),React.createElement("rect",{"fill":"#4a90e2","stroke":"#000","strokeMiterlimit":"10","x":"0.5","y":"0.5","width":"21","height":"21","key":1})]);
}

DifficultyLevelBlueOutline.defaultProps = {"role":"presentation","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 22 22"};

module.exports = DifficultyLevelBlueOutline;

DifficultyLevelBlueOutline.default = DifficultyLevelBlueOutline;
